module.exports = __webpack_public_path__ + "static/img/feilipu.17764f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/feilipu.jpg
// module id = MSAB
// module chunks = 0